<template>

  <label class="checkbox">
    <input type="checkbox" v-model="action.nextids" :value="answer.action.nextid" />
    <span>{{ checkboxText }}</span>
  </label>

</template>

<style lang="scss">
.checkbox {
  display: inline-block;
  padding: 8px 24px 8px 0;
  span {
    color: #004F45 !important;
    padding: 0 0 0 8px;
  }
}
</style>

<script>
export default {

  name: 'VaDecisionCheckbox',

  props: {
    answer : { type: Object, required: true },
    action : { type: Object, required: true },
  },

  computed: {

    checkboxText () {
      return this.text || this.answer.text || '';
    }
  }

};
</script>
